import React from 'react';
import { Select, MenuItem, FormControl } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core';
import { designTokens } from '../../styles/designTokens';
import Button from '../Button';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles({
    root: {
        padding: `0 ${designTokens.spacing.lg} ${designTokens.spacing.lg}`,
        '@media (max-width: 640px)': {
            padding: `0 ${designTokens.spacing.sm} ${designTokens.spacing.sm}`,
        },
    },
    wrapper: {
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
},
    container: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        paddingTop: designTokens.spacing.sm,
        alignItems: 'center',
        '@media (max-width: 900px)': {
            flexDirection: 'column',
            alignItems: 'stretch',
        }
    },
    label: {
        ...designTokens.typography.body,
        whiteSpace: 'nowrap',
    },
    formControl: {
        flex: 1,
        minWidth: 300,
        maxWidth: 536,
        '@media (max-width: 900px)': {
            minWidth: 'auto',
            width: '100%',
        },
    },
    select: {
        backgroundColor: designTokens.colors.background.card,
        borderRadius: designTokens.borderRadius.button,
        border: `1px solid ${designTokens.colors.border} !important`,
        '& fieldset': {
            border: 'none !important',
        },
        '&:hover': {
            border: `1px solid ${designTokens.colors.border} !important`,
        },
        '&:hover fieldset': {
            border: 'none !important',
        },
        '&.Mui-focused': {
            border: `1px solid ${designTokens.colors.border} !important`,
        },
        '&.Mui-focused fieldset': {
            border: 'none !important',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
        }
    },
    selectInput: {
        padding: '13px 16px 12px !important',
        backgroundColor: 'transparent !important',
        borderRadius: designTokens.borderRadius.button,
        ...designTokens.typography.body,
        '&:focus': {
            backgroundColor: 'transparent !important',
            outline: 'none !important',
        },
    },
    selectIcon: {
        color: designTokens.colors.primary,
        right: '12px',
    },
    addButtonWrapper: {
        '@media (max-width: 900px)': {
            width: '100%',
        }
    },
    menuPaper: {
        marginTop: '2px',
        borderRadius: designTokens.borderRadius.card,
        border: `1px solid ${designTokens.colors.border}`,
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    },
    menuItem: {
        ...designTokens.typography.body,
        padding: '12px 16px',
        '&:hover': {
            backgroundColor: designTokens.colors.grey[100],
        },
        '&.Mui-selected': {
            backgroundColor: designTokens.colors.primary + '20',
            '&:hover': {
                backgroundColor: designTokens.colors.primary + '30',
            }
        }
    }
});

const PatientSelector = ({
    selectedPatient,
    patients = [],
    onChange,
    onAddPatient
}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.wrapper}>
                <span className={classes.label}>Призначити пацієнта:</span>

                <div className={classes.container}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <Select
                            value={selectedPatient?.id || ''}
                            onChange={(e) => {
                                const patient = patients.find(p => p.id === e.target.value);
                                onChange(patient);
                            }}
                            displayEmpty
                            className={classes.select}
                            IconComponent={ExpandMoreIcon}
                            classes={{
                                select: classes.selectInput,
                                icon: classes.selectIcon,
                            }}
                            MenuProps={{
                                classes: {
                                    paper: classes.menuPaper,
                                },
                                anchorOrigin: {
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                },
                                transformOrigin: {
                                    vertical: 'top',
                                    horizontal: 'left',
                                },
                                getContentAnchorEl: null,
                            }}
                        >
                            <MenuItem value="" disabled className={classes.menuItem}>
                                Оберіть пацієнта
                            </MenuItem>
                            {patients.map(patient => (
                                <MenuItem key={patient.id} value={patient.id} className={classes.menuItem}>
                                    {patient.fullname}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <div className={classes.addButtonWrapper}>
                        <Button
                            variant="outlined"
                            onClick={onAddPatient}
                            icon={<AddIcon />}
                            iconPosition="left"
                            size="small"
                        >
                            Додати за номером телефону
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PatientSelector;
